import { render, staticRenderFns } from "./rechargeConfig.vue?vue&type=template&id=9587aad2&scoped=true&"
import script from "./rechargeConfig.vue?vue&type=script&lang=js&"
export * from "./rechargeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9587aad2",
  null
  
)

export default component.exports